import StoreGroupDirectory from "@/modules/storeGroups/components/StoreGroupDirectory";
import StoreGroupEditor from "@/modules/storeGroups/components/StoreGroupEditor";
import { PATH_DICTS_STORE_GROUPS } from "@/constants";
import { createDictionaryLabels } from "@/containers/dictionaries/createDictionaryLabels";
import { Module } from "@/constants";
import { getDictionaryLabels } from "@/containers/dictionaries/getDictionaryLabels";
import { DictionaryConfig } from "@/containers/dictionaries/types";
import { StoreGroupService } from "@/modules/storeGroups/service";
import { Group } from "lucide-react";
import { ReadStoreGroup } from "@/types/storeGroup";
import { StoreGroupForm } from "@/modules/storeGroups/types";
import { storeGroupFormSchema } from "@/modules/storeGroups/schema";
const id = Module.StoreGroups;
const path = PATH_DICTS_STORE_GROUPS;
const ns = "storeGroups";

const config: DictionaryConfig<ReadStoreGroup, StoreGroupForm> = {
  id,
  ns,
  service: StoreGroupService,
  path,
  labels: createDictionaryLabels(ns, {
    dict: "navigation.storeGroups",
    new: `${ns}.new`,
  }),
  getLabels: getDictionaryLabels,
  schema: storeGroupFormSchema,
  defaultValues: { name: "", description: "" },
  Icon: Group,
  Creator: () => null,
  Editor: StoreGroupEditor,
  List: StoreGroupDirectory,
};

export default config;
